import * as Styled from "./style";
import { useHandleClickByDevice } from "~/hooks/use-handle-click-by-device";
import type { G_VideoPpvExpiration, G_VideoSvodProduct, Maybe } from "~/lib/graphql";
import { G_ServicePlan } from "~/lib/graphql";
import { useAuth } from "~/provider/auth";
import { goToWelcomePage } from "~/util/go-to-welcome-page";

type PurchaseBannerProps = {
  svodProduct: Maybe<Pick<G_VideoSvodProduct, "contentId">> | undefined;
  ppvExpiration: Maybe<Pick<G_VideoPpvExpiration, "expirationType">> | undefined;
};

export const PurchaseBanner = (props: PurchaseBannerProps) => {
  const { svodProduct, ppvExpiration } = props;

  const { servicePlan } = useAuth();
  const { handleClickByDevice } = useHandleClickByDevice();

  // 購入していた場合、プレミアム訴求導線を表示しない
  if (ppvExpiration !== undefined && ppvExpiration !== null) return null;

  // SVOD取扱商品でない場合、プレミアム訴求導線を表示しない
  if (svodProduct === undefined || svodProduct === null) return null;

  // プレミアム会員の場合、プレミアム訴求導線を表示しない
  if (servicePlan === G_ServicePlan.Premium) return null;

  return (
    <Styled.SecRootBannerContainer>
      <Styled.Heading>プレミアム会員の方は追加料金なしで視聴できます</Styled.Heading>

      <Styled.ButtonActionWrapper
        type="button"
        name="プレミアム入会導線ボタン"
        aria-label="プレミアム入会導線ボタン"
        {...handleClickByDevice(() => goToWelcomePage())}
      >
        <section>
          <p>
            <Styled.SpanFont>DMMプレミアム</Styled.SpanFont>
            <span>ならこの作品を含む対象の作品が見放題！</span>
          </p>
          <Styled.ParContent>まずは30日間無料トライアル！</Styled.ParContent>
        </section>

        <Styled.ArrowRightIcon name="arrowRight" size="XL" />
      </Styled.ButtonActionWrapper>
    </Styled.SecRootBannerContainer>
  );
};
